import {useEffect, useState} from "react";
import FormButton from "../../../components/form-button";
import {toast} from "react-toastify";
import associateServices from "../../../services";
import {useTranslation} from "react-i18next";
import STRING_HELPER from "../../../helpers/string-helper";
import InformationToast from "../../../components/toast/InformationToast";
import SvgIcon from "../../../components/svg-icon";
import store from "../../../reducers/createReducers";
import AUTHENTICATION_ACTIONS from "../../../actions/authentication-actions";
import PhoneInput from "react-phone-input-2";
import {useSelector} from "react-redux";
import tr from 'react-phone-input-2/lang/tr.json'

const ForgotPassword = props => {

    const {handleClose, handleModalAction} = props
    const {configuration} = useSelector(state => state.globalReducer)

    const {t} = useTranslation()
    const [step, setStep] = useState('email')
    const [showError, setShowError] = useState('')
    const [secret, setSecret] = useState('')
    const [type, setType] = useState('email')
    const [email, setEmail] = useState('')
    const [defaultCountry, setDefaultCountry] = useState('tr')
    const [password, setPassword] = useState('')
    const [otp, setOtp] = useState('')

    const [submitting, setSubmitting] = useState(false)

    useEffect(() => {
        console.log('configuration?.country = ,', configuration?.country)
        setDefaultCountry(configuration?.country?.toLowerCase())
    }, [configuration?.country])


    const handleChangePhone = (phone, country) => {
        setEmail(phone)
        setDefaultCountry(country?.countryCode)
    }

    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('pass-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'
    }, [])

    // const handleClose = () => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))

    const handleForgotPassword = () => {
        if (!email)
            return setShowError(t('general.form-field-cant-be-null'))

        if (type === 'email' && !STRING_HELPER.isEmailValid(email))
            return setShowError(t('general.enter-a-valid-email'))

        console.log('email = ', email)
        if (type === 'phone' && !email) {
            return setShowError(t('general.enter-a-valid-number'))
        }

        setSubmitting(true)
        associateServices.forgotPassword({email, type})
            .then(handleForgotPasswordResponse)
    }
    const handleForgotPasswordOTP = () => {
        if (!otp)
            return setShowError(t('general.form-field-cant-be-null'))

        setSubmitting(true)


        associateServices.forgotPasswordOtp({secret, code: otp})
            .then(handleForgotPasswordOtpResponse)
    }
    const handleForgotPasswordPassword = () => {
        if (!password)
            return setShowError('form-field-cant-be-null')

        setSubmitting(true)

        associateServices.forgotPasswordPassword({
            secret,
            code: otp,
            password
        })
            .then(handleForgotPasswordPasswordResponse)
    }

    const handleForgotPasswordResponse = response => {
        setSubmitting(false)
        if (response?.status !== 200)
            return toast(<InformationToast
                icon={'ti-error-404'}
                title={'...'}
                message={t(`api-notifications.${response?.errors}`)}
            />)

        toast(<InformationToast
            icon={'ti-info-circle'}
            title={'...'}
            message={t(`forgot-password.enter-otp-code`)}
        />)


        setSecret(response?.data)
        setStep('otp')
        setShowError(null)
    }
    const handleForgotPasswordOtpResponse = response => {
        setSubmitting(false)
        if (response?.status !== 200)
            return toast(<InformationToast
                icon={'ti-error-404'}
                title={'...'}
                message={t(`api-notifications.${response?.errors}`)}
            />)

        toast(<InformationToast
            icon={'ti-info-circle'}
            title={'...'}
            message={t('forgot-password.set-your-new-password')}
        />)
        setShowError(null)
        setStep('password')
    }
    const handleForgotPasswordPasswordResponse = response => {
        setSubmitting(false)
        if (response?.status !== 200)
            return toast.error(response?.errors)


        toast(<InformationToast
            icon={'ti-check'}
            title={'...'}
            message={t('forgot-password.your-password-has-been-updated')}
        />)

        handleClose()
        // handleModalAction('login')
        // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction('login'))

        store.dispatch(AUTHENTICATION_ACTIONS.setUserToken(response?.data))
    }


    const handleAction = () => {
        switch (step) {
            case 'email':
                return handleForgotPassword();

            case 'otp':
                return handleForgotPasswordOTP();


            case 'password':
                return handleForgotPasswordPassword();

            default:
                return false;
        }
    }

    return (
        <div
            className="modal fade"
            id="pass-modal"
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title">{t('forgot-password.title')}</h6>
                            <button
                                className="modal__close"
                                type="button"
                                onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>

                        <ul className="nav nav-tabs tabs-nav tabs-nav--modal">
                            <li onClick={e => setType('email')} className="nav-item" role="presentation">
                                <button className={`tabs-nav__btn ${type === 'email' ? 'active' : ''} gap-2`} type="button">
                                    <SvgIcon id={'email'}/>
                                    E-mail
                                </button>
                            </li>

                            <li onClick={e => setType('phone')} className="nav-item" role="presentation">
                                <button className={`tabs-nav__btn ${type === 'phone' ? 'active' : ''} gap-2`} type="button">
                                    <SvgIcon id={'phone'}/>
                                    SMS
                                </button>
                            </li>
                        </ul>
                        <div className="modal__form">

                            {
                                step === 'email' ? <div className="form__group">

                                        {
                                            type === 'email' ? <>
                                                    <label htmlFor="" className="form__label">
                                                        {t('forgot-password.email')}<b>*</b>
                                                    </label>
                                                    <input value={email} onChange={e => setEmail(e.target.value)} type="text"
                                                           className="form__input"/>
                                                </>
                                                :
                                                <>
                                                    <label htmlFor="" className="form__label">
                                                        {t('forgot-password.phone', 'Phone Number')}<b>*</b>
                                                    </label>
                                                    <PhoneInput
                                                        searchPlaceholder={t('general.search')}
                                                        inputClass={'form__input'}
                                                        country={defaultCountry}
                                                        localization={configuration?.country?.toUpperCase() === 'CY' && tr}
                                                        enableSearch={true}
                                                        value={email}
                                                        onChange={handleChangePhone}
                                                    />
                                                </>

                                        }

                                    </div>

                                    :
                                    step === 'otp' ?
                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                {t('forgot-password.otp-code')}<b>*</b>
                                            </label>
                                            <input value={otp} onChange={e => setOtp(e.target.value)}
                                                   type="number"
                                                   className="form__input"/>
                                        </div>
                                        :

                                        <div className="form__group">
                                            <label htmlFor="" className="form__label">
                                                {t('forgot-password.password')}<b>*</b>
                                            </label>
                                            <input value={password} onChange={e => setPassword(e.target.value)}
                                                   type="text" className="form__input"/>
                                        </div>
                            }


                            {
                                showError &&
                                <p className="form__note error">
                                    * {showError}
                                </p>
                            }


                            <FormButton
                                label={t('forgot-password.send')}
                                loading={submitting}
                                disabled={submitting || !email}
                                onClick={handleAction}
                            />

                            {
                                step !== 'password' &&
                                <div className="form__text">
                                    <p>{t('forgot-password.description')}</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )

}

export default ForgotPassword
